<div class="atn-mosaic-report-card">
  @for (group of widgetStore.contentSg(); track $index) {
    <atn-ds-section [name]="group.name">
      @for (metric of group.values; track $index) {
        <div class="atn-mosaic-report-card__metric-wrapper">
          <!-- TODO: Figure out a way to support overflow actions in report-card -->
          <atn-widget-metric
            [metric]="metric"
            [refId]="widgetStore.refIdSg()"
            [isReportCard]="true"
          />
        </div>
      }
    </atn-ds-section>
  }
</div>
